import utils from '../utils';
import context from '../context';
import getTimeOffDates from '../process/getTimeOffDates';
import getPartialDuration from '../process/getPartialDuration';
import { DISPLAY_MODES } from '../constants';

export default function isEventVisibleWithinDates(event, displayMode, days) {
  const daysDict = {};
  // not using reduce here because it's slow
  days.forEach((day) => {
    daysDict[day] = true;
  });

  if (context.isTimeOff(event.type) || event.type === 'availability') {
    return isTimeOffVisibleWithinDays(event, displayMode, days, daysDict);
  }

  return isShiftVisibleWithinDays(event, displayMode, days, daysDict);
}

function isTimeOffVisibleWithinDays(event, displayMode, relevantDays, relevantDaysDict) {
  return getTimeOffDates(event, displayMode, relevantDays).some(
    (day) => relevantDaysDict[utils.formatDate(day)]
  );
}

function isShiftVisibleWithinDays(event, displayMode, relevantDays, relevantDaysDict) {
  const { visibleHoursStart, visibleHoursEnd } = context.orgSettings;

  const days = utils.getBusinessDaysBetween(
    visibleHoursStart,
    visibleHoursEnd,
    event,
    relevantDays
  );

  if (displayMode === DISPLAY_MODES.DAY) {
    return days.some((day) => relevantDaysDict[day]);
  }

  const dtstartDateString = utils.toDateString(event.dtstart);
  if (!days.includes(dtstartDateString)) {
    days.push(dtstartDateString);

    return days.some((day) => relevantDaysDict[day]);
  }

  if (
    days.length === 1 &&
    getPartialDuration(event, 1, context.laborCostSettings?.shiftSplitTime)
  ) {
    days.push(utils.formatDate(utils.addDays(days[0], 1)));
  }

  return days.some((day) => relevantDaysDict[day]);
}
